import React from "react";
import "./Contact.css";
import { VscGithub } from "react-icons/vsc";
import { CgMail } from "react-icons/cg";
import { BsInstagram, BsFillTelephoneFill } from "react-icons/bs";
import { ThemeContext } from "../../Context/theme";

import { FaLinkedin } from "react-icons/fa";
import ContactForm from "./ContactForm/ContactForm";
export const Contact = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <div className="section">
      {/* data-aos="fade-left" */}
        <h2 className="section__title" >
          Get in <span className="different">Touch</span>
        </h2>

        <div className="contactMain">
          <div
            className={"contactcontainer " + themename}
            // data-aos="fade-right"
            >
          <ContactForm/>
          <div className="contactcontainer socialButtons">
            <a
              href="https://www.linkedin.com/in/suvranilghose/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin className="linkedin" />
            </a>
            <a
              href="https://github.com/SuvranilG"
              target="_blank"
              rel="noreferrer"
            >
              <VscGithub className="github" />
            </a>
            <a
              href="mailto:technicalsuvranil@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              <CgMail className="email" />
            </a>
            <a href="tel:+918658249899" target="_blank" rel="noreferrer">
              <BsFillTelephoneFill className="phone" />
            </a>
            </div>
          </div>
          {/* data-aos="fade-right" */}
          <div className="mailNumber">
            <div>
              <span>
                <CgMail className="email" />
              </span>
              <span>
                <p>technicalsuvranil@gmail.com</p>
              </span>
            </div>
            <div className="iconsCont">
              <span>
                <BsFillTelephoneFill className="phone" />
              </span>
              <span>
                <p>+91 8658249899</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
